export const cilPaint = ["24 24","<path d='M19.126 3.375h-1.126v-1.5c-0.001-0.621-0.504-1.124-1.125-1.125h-13.5c-0.621 0.001-1.124 0.504-1.125 1.125v4.875c0.001 0.621 0.504 1.124 1.125 1.125h13.5c0.621-0.001 1.124-0.504 1.125-1.125v-1.875h1.126c1.035 0 1.874 0.839 1.874 1.874 0 0.934-0.684 1.709-1.578 1.851l-0.011 0.001-8.161 1.255v3.268h-2.625v10.125h6.75v-10.125h-2.625v-1.982l6.889-1.060c1.63-0.258 2.861-1.652 2.861-3.335 0-1.863-1.511-3.374-3.374-3.374-0 0-0 0-0 0v0zM16.5 6.375h-12.75v-4.125h12.75zM13.875 21.75h-3.75v-7.125h3.75z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-paint.js
// module id = null
// module chunks = 